/**
 * Picks a localized string from a backend i18n envelope `{fa, en}`.
 *
 * Order: `fa` (Persian — primary), then `en` (English fallback), then the
 * caller-provided fallback label. Always returns a string; never JSON-stringifies.
 *
 * Centralizes the lookup because the backend swagger types `name` /
 * `description` as `{[key: string]: unknown}` (loose Object annotation).
 * Wrapping that lookup here keeps callers free of defensive narrowing
 * (`feedback_backend_response_typing.md`).
 */
export function localize(value: unknown, fallback: string = ""): string {
  if (value === null || value === undefined || typeof value !== "object") {
    return fallback;
  }
  if ("fa" in value && typeof value.fa === "string" && value.fa.length > 0) {
    return value.fa;
  }
  if ("en" in value && typeof value.en === "string" && value.en.length > 0) {
    return value.en;
  }
  return fallback;
}
